export default {
  "content": "<path d=\"M5 18h14v-6h2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6h2v6z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 3a2 2 0 012 2v4a1 1 0 01-1 1H4a1 1 0 01-1-1V5a2 2 0 012-2h14zM5 8h14V5H5v3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};